// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__qZv+U","fixed":"loader_fixed__TlLmM","pulse":"loader_pulse__1g-OO"};